import React , {useState , useEffect} from 'react'
import '../../CSS/style.css'
import '../../CSS/responsive.css'
import { collection , getDocs  } from 'firebase/firestore'
import { Firestore_db } from '../firebase_config_programs'
import QuesSolTemplate from '../question_solution_template'
import Loader from '../loader'
const db_ref = collection(Firestore_db , 'Python');






export default function Python() {
 const [isLoading , setIsLoading] = useState(false);
const [ques, setQues] = useState([]);
const [sol , setSol] = useState([]);
const [output , setOutput] = useState([]);
useEffect(()=>{
  setIsLoading(true);
  getDocs(db_ref)
  .then((snapshot)=>{
    
    snapshot.docs.forEach(async (doc)=>{
      
      var questionsData = await { ...doc.data().questions}
      var solutionsData = await { ...doc.data().solutions}
      var outputData = await { ...doc.data().output}
      setIsLoading(false);

      setQues(questionsData);
      setSol(solutionsData) ;
      setOutput(outputData);
    })
  })

},[])
// console.log(ques);
 
  return (
    <>
    <div className="p-heading m-auto">Python Programs</div>
    {isLoading  ? <Loader /> : 
      <div className="quesSolContainer m-auto" >
         <QuesSolTemplate questions={ques} solutions={sol} output={output} />
         
          {/* <div className="sec-heading questions" >{ques}</div> */}
        {/* <div className="programs m-auto">{sol}</div> */}
        
      </div>}
    </>
  )
}
